// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"a2836df1","171":"f00638ff","338":"f00638ff","404":"f00638ff","441":"40ab3a5b","743":"f00638ff"}[chunkId] + ".chunk.css";
};